import { ICardContractGenerateDoc } from './types'

import imgEmty from '@img/empty.svg'
import { IconClearClose } from '@img/icons'

import { Empty, Flex, Modal, Loader, Input, Divider, Button, Table, Container } from '@ui/index'


/** Окно по выбору документов для формирования */
export const CardContractGenerateDoc = ({
    isOpen, isLoading, txtSum, documentsList, handlerSelectedDocuments, handlerBtnSave, handlerButtonCancel
}: ICardContractGenerateDoc) => {
    let oldSectionName: string = ''
    const getDivider = (sectionName: string, index: number) => {
        if (oldSectionName !== sectionName) {
            oldSectionName = sectionName
            return <div style={{paddingTop: index > 0 ? '15px' : '0'}}><Divider gap='6px' prefix={<h4>{sectionName}</h4>} /></div>
        }
    }

    return <>
        <Modal isOpen={isOpen} isEsc onCancel={handlerButtonCancel} overflowY="hidden" maxWidth="350px">
            <Flex className='modal_container'>
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>Выбор документов</h4>

                    <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Container padding='6px'>
                    <Flex className='modal_container-content'>
                        <Loader isOpen={isLoading} backdrop title='Загрузка...' />

                        <Table.Content isScrollVertical={false} minHeight='200px'>
                            {!documentsList.value
                                ? <Empty image={imgEmty} title="Документы отсутствуют" />
                                : documentsList.value.map((item, index) => {
                                    return (
                                        <Flex key={index}>
                                            {getDivider(item.category, index)}

                                            <Table.RowCheckBox header={<IconClearClose width='16px' height='16px' />} headerWidth="40px" isSelected={item.isSelect} onClick={(e) => handlerSelectedDocuments(item.id)}>
                                                <Flex gap='4px'>
                                                    <p>{item.name}</p>
                                                    <Input size='md' {...txtSum}
                                                        maxLength={15}
                                                        placeholder='Расчёт по умолчанию'
                                                        prefix={<span style={{textWrap: 'nowrap'}}>Сумма, ₽:</span>}
                                                        isRendered={item.id === 4 && item.isSelect}
                                                    />
                                                </Flex>
                                            </Table.RowCheckBox>
                                        </Flex>
                                    )
                                })
                            }
                        </Table.Content>
                    </Flex>

                    <Button width='100%' onClick={handlerBtnSave}>Сформировать</Button>
                </Container>
            </Flex>
        </Modal>
    </>
}